import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: {
      auth: true,
    }
  },
  {
    path: '/jobs',
    name: 'job',
    component: () => import('../views/job/JobView.vue'),
    meta: {
      auth: true,
    }
  },
  {
    path: '/manage-job/:id',
    name: 'manage-job',
    props: true,
    component: () => import('../views/job/ManageJobView.vue'),
    meta: {
      auth: true,
    }
  },
  {
    path: '/users',
    name: 'user',
    component: () => import('../views/user/UserView.vue'),
    meta: {
      auth: true,
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/SettingsView.vue'),
    meta: {
      auth: true,
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue'),
    meta: {
      auth: true,
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.auth.loggedIn
  const requiresAuth = to.matched.some(x => x.meta.auth)

  if (requiresAuth && isAuthenticated == false) {
    next('/')
  } else if (to.name == 'login' && isAuthenticated == true) {
    next('/home')
  } else {
    next()
  }
})


export default router
